import { observer } from "mobx-react-lite";
import React, { FC, useContext, useState } from "react";
import { Context } from "..";
import UserCard from "./UserCard";

const AllUsers: FC = () => {
  const { store } = useContext(Context);
  const users = store.users;
  const [filter, setFilter] = useState<string>("auth-all");

  return (
    <div className="profile">
      <div className="profile__select select">
        <button className="select__button">{filter === 'auth-true' ? 'Підтверджені' : filter === 'auth-false' ? 'Не підтверджені' : 'Усі'}</button>
        <div className="select__list">
          <fieldset className="select__field">
            <input className="select__input" type="radio" name="filter-auth" id="auth-all" checked={filter === "auth-all"} onChange={() => setFilter("auth-all")} />
            <label className="select__radio" htmlFor="auth-all">Усі</label>
          </fieldset>
          <fieldset className="select__field">
            <input className="select__input" type="radio" name="filter-auth" id="auth-true" checked={filter === "auth-true"} onChange={() => setFilter("auth-true")} />
            <label className="select__radio" htmlFor="auth-true">Підтверджені</label>
          </fieldset>
          <fieldset className="select__field">
            <input className="select__input" type="radio" name="filter-auth" id="auth-false" checked={filter === "auth-false"} onChange={() => setFilter("auth-false")} />
            <label className="select__radio" htmlFor="auth-false">Не підтверджені</label>
          </fieldset>
        </div>
      </div>
      <a className="profile__download" href={process.env.REACT_APP_BASE_URL + "/download"}>Завантажити список усіх користувачів</a>
      <div className="profile__users">
        {users && users.map((user) => filter === 'auth-true'
          ? user.isActivated === true
            ? <UserCard userActive={user} key={user.id} />
            : ''
          : filter === 'auth-false'
            ? user.isActivated === false
              ? <UserCard userActive={user} key={user.id} />
              : ''
            : <UserCard userActive={user} key={user.id} />)}
      </div>
    </div>
  );
};

export default observer(AllUsers);
